import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m7.707 7 3.647-3.646a.5.5 0 0 0-.708-.708L7 6.293 3.354 2.646a.5.5 0 1 0-.708.708L6.293 7l-3.647 3.646a.5.5 0 1 0 .708.708L7 7.707l3.646 3.647a.5.5 0 0 0 .708-.708z" }, null, -1)
  ])))
}
export default { render: render }